<!-- Discard Tags Modal -->
<div class="modal fade slide-in-bottom" id="tagsDiscardModal" tabindex="-1" aria-labelledby="tagsModal" aria-hidden="true" data-backdrop="static" [ngStyle]="{'display': true ? 'block' : 'none','opacity': 1,'background' : 'rgba(0,0,0,0.5)','backdrop-filter':'blur(10px)', 'transition':'all ease-in .1s'}">
    <div class="modal-dialog modal-dialog-centered modal-sm w-discard">
        <div class="modal-content">
            <div class="modal-header">
                <h1>Discard changes</h1>
                <div class="modal-close close btn-pos" data-dismiss="modal" aria-label="Close" (click)="keepChanges()">
                    <!-- <em class="esc d-none d-lg-inline-block">esc</em>
                    <span class="Neueclosefilled"></span> -->
                    <span [ngClass]="[universalService.isMobileDevice ? 'Neueclosefilled' : 'NeueFile_Cancel']"></span>
                    <span class="esc">esc</span>
                </div>
            </div>
            <div class="modal-body discard-txt">
                <p>Do you want to discard changes?</p>
            </div>

            <!-- Footer -->
            <div class="modal-footer discard-footer">
                <div class="btn-wrap">
                    <button class="mr-3"  id="yes" data-dismiss="modal" aria-label="Close" (click)="exitChanges()">Yes</button>
                    <button class="" id="no" data-dismiss="modal" aria-label="Close" (click)="keepChanges()">No</button>
                </div>
            </div>

        </div>
    </div>
</div>